















import { Vue, Component } from "vue-property-decorator";
import {CommonConstant} from "@/common-constant";

@Component
export default class Error extends Vue {
    /** 共通ID表示名 */
    commonIdName: string = CommonConstant.COMMON_ID_NAME;

    created() {
        sessionStorage.clear();
    }

    reLogin() {
        // ログアウトした場合はNavigation Guardにより、ログインページが表示される。
        this.$router.push("/client/mypage");
    }
}
